import { useCallback } from "react";
import apiClient2 from "../../api/apiClient2";
import apiPaths from "../../api/endpoints";

export interface HeartCornerEmotionPayload {
  heartConvoType: string; // e.g. "pre-limit"
  emotionType: string; // e.g. "happy"
}

/**
 * Mirrors srcMobile/Screens/HeartCorner/useHeartCorner.tsx
 * POST /updateHeartConvoWithEmotion with { heartConvoType, emotionType }
 */
export function useHeartCorner() {
  const postHeartCorner = useCallback(
    async (data: HeartCornerEmotionPayload) => {
      try {
        const res = await apiClient2.post(apiPaths.UPDATE_HEART_CORNER, data);
        return res?.data;
      } catch (err: any) {
        console.error("postHeartCorner error:", err);
        return null;
      }
    },
    [],
  );

  return { postHeartCorner };
}

export interface StoryUpdatePayload {
  storyId?: string;
  blocks?: Array<{ id: number | string; status: string }>;
  emotion?: string;
  name?: string;
  template?: Array<{ name: string; status: boolean }>;
}

/**
 * Mirrors srcMobile usePostStoryData — PUT /v3/updateStory.
 * Used after the Heart Corner emotion selection to mark the heart block
 * complete and progress the story (mobile: updateStoryModule).
 */
export function usePostStoryData() {
  const postStoryData = useCallback(async (data: StoryUpdatePayload) => {
    try {
      const res = await apiClient2.put(apiPaths.POST_STORY_UPDATE, data);
      return (res?.data?.data ?? res?.data) ?? null;
    } catch (err: any) {
      console.error("postStoryData error:", err);
      return null;
    }
  }, []);
  return { postStoryData };
}
